import type { RouteObject } from 'react-router';

/** Catch-all; must stay the last public route. */
export const notFoundRoutes: RouteObject = {
  path: '*',
  lazy: () => import('./NotFoundPage').then((m) => ({ Component: m.NotFoundPage })),
};
